export default __webpack_public_path__ + "static/media/logo.07f5ddd9.png";